import React, {PureComponent} from "react"
import * as PropTypes from "prop-types"

import {connect} from "@irati/store"
import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import walletBadge from "@irati-web/wallet/src/images/wallet_badge.svg"
import {ReduxState} from "@irati/store/types"
import {Body, H3} from "@irati/ui/src/Typography"

import {Image, ImageTextWrapper, GridWrapper, StyledRouterLink} from "./styled/CategoryHeaders"

interface Props {
  className?: string,
  onButtonClick?: () => void,
  wallet: Wallet
}

class SpendCategoryHeader extends PureComponent<Props> {
  static defaultProps = {
    className: null,
    onButtonClick: () => {}
  }

  static contextTypes = {
    apps: PropTypes.object.isRequired
  }

  render() {
    const {className, onButtonClick, wallet} = this.props
    const {availableBalance, currency} = wallet
    const {apps} = this.context

    return (
      <>
        <GridWrapper className={className}>
          <ImageTextWrapper>
            <Image src={walletBadge} />
            <div>
              <H3 paddingBottom={0.5}>
                <FormattedMessage id="perks.categories.spendCategoryHeader.title" />
              </H3>
              <Body small overflow="hidden">
                {availableBalance ? (
                  <FormattedMessage
                    id="perks.categories.spendCategoryHeader.hasBalanceSubText"
                    values={{value: <FormattedCurrency isCents={false} value={availableBalance} currency={currency} />}} />
                ) : (
                  <FormattedMessage id="perks.categories.spendCategoryHeader.noBalanceSubText" />
                )}
              </Body>
            </div>
          </ImageTextWrapper>
          <StyledRouterLink primary to="/" app={apps.WALLET} onClick={onButtonClick}>
            <FormattedMessage id="perks.categories.spendCategoryHeader.buttonText" />
          </StyledRouterLink>
        </GridWrapper>
      </>
    )
  }
}

const mapStateToProps = ({wallet}: ReduxState) => ({wallet})

export default connect(mapStateToProps)(SpendCategoryHeader)
